<template>
  <v-dialog
    v-model="valorModel"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar flat dark color="#042333">
        <v-btn icon @click="fechar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Relatório Status Produtos</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pa-0">
        <sys-data-table
          id="data-table-dialog-status-produto"
          v-model="itens_selecionados_tabela"
          :headers="HEADERS_COMP"
          :items="desserts"
          :search="pesquisar"
          :loading="loading_table"
          :item-height="15"
          :height="alturaDaJanela - 180"
          :items-per-page="-1"
          :fixed-header="true"
          :item-class="classesProduto"
          item-key="idproduto"
          class="font-resp-tabela table-full-screen"
          @scroll-items="buscarProdutosSeTiverNoFinalDaRolagem($event)"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <h4 class="ml-n3">Grupo: {{ grupoCompra }}</h4>

              <v-divider class="mx-1" inset vertical></v-divider>

              <h4>Filial: {{ filialCompra == 0 ? 'Todas' : filialCompra }}</h4>

              <v-divider class="mx-1" inset vertical></v-divider>

              <h4>Periodo: {{ MES_ANO }}</h4>

              <v-divider class="mx-1" inset vertical></v-divider>

              <h4>Status: {{ STATUS_FORMATADO }}</h4>

              <v-spacer></v-spacer>

              <FiltroPorNivelDeEstoque
                v-if="!parametros_dialog.selecionado_grid"
                v-model="nivel_estoque"
                :itens-object="niveisDeEstoque"
                class="mr-5"
                dense
                style="max-width: 350px"
              ></FiltroPorNivelDeEstoque>

              <v-text-field
                v-model="pesquisar"
                append-icon="mdi-magnify"
                label="Pesquisa"
                class="ml-5 mr-5 mt-1"
                single-line
                hide-details
                clearable
                dense
                v-lazy-input:debounce="500"
                style="max-width: 450px"
              ></v-text-field>

              <v-btn
                color="primary"
                title="Exportar Para Excel"
                @click="exportarRelatorio()"
              >
                <v-icon left>mdi-file-export</v-icon>Exportar
              </v-btn>
            </v-toolbar>
          </template>

          <template #item.razao_social="{ value }">
            <span class="d-flex">{{ value }}</span>
          </template>

          <template #item.descricao_produto="{ item }">
            <div class="d-flex">
                <DetalhamentoProduto
                  :produto="item"
                  exibir_raio_x
                ></DetalhamentoProduto>
                {{ item.descricao_produto }}
            </div>
          </template>

          <template #item.excesso="{ value }">
            {{ Helpers.formatarValorComCasas(value, 0) + ' dias' }}
          </template>

          <template #item.adequado="{ value }">
            {{ Helpers.formatarValorComCasas(value, 0) + ' dias' }}
          </template>

          <template #item.baixa_exposicao_ruptura="{ value }">
            {{ Helpers.formatarValorComCasas(value, 0) + ' dias' }}
          </template>

          <template #item.elevada_exposicao_ruptura="{ value }">
            {{ Helpers.formatarValorComCasas(value, 0) + ' dias' }}
          </template>

          <template #item.ruptura="{ value }">
            {{ Helpers.formatarValorComCasas(value, 0) + ' dias' }}
          </template>

          <template #item.com_pedido="{ value }">
            {{ Helpers.formatarValorComCasas(value, 0) + ' dias' }}
          </template>

          <template #item.sem_pedido="{ value }">
            {{ Helpers.formatarValorComCasas(value, 0) + ' dias' }}
          </template>

          <template #item.estoque="{ value }">
            {{ Helpers.formatarValorComCasas(value, 2) }}
          </template>

          <template #item.lista_pedidos_em_aberto="{ item }">
            <PedidosEmTransitoDialog
              v-if="item.lista_pedidos_em_aberto.length > 0"
              :produto="item"
              :disabled="loading_table"
            ></PedidosEmTransitoDialog>

            <p
              v-else
              class="ma-0 pr-5 text-center"
              v-text="'Nenhum'"
            ></p>
              <!-- :class="corTextoItemForaDeLinha(item)" -->
          </template>

          <template #item.opcoes="{ item }">
            <v-tooltip
              v-if="item.status === 'FL'"
              top
              open-delay="700"
            >
              <template v-slot:activator="{on, attrs}">
                <v-btn icon color="error" v-bind="attrs" v-on="on">
                  <v-icon>mdi-alert</v-icon>
                </v-btn>
              </template>

              <span>Produto Fora de Linha</span>
            </v-tooltip>

            <v-btn v-else icon :disabled="loading_table" @click="pushTelaCompras(item)">
              <v-icon>mdi-cart</v-icon>
            </v-btn>
          </template>

          <template #body.append v-if="todos_itens_paginados_carregados && desserts.length > 0">
            <div class="d-flex align-center justify-center py-4 text-gray-400">
              <v-icon left>mdi-sort-descending</v-icon>
              FIM DA TABELA
            </div>
          </template>

          <template #footer="{countItems}">
            <FooterDataTable :countItems="countItems" class="px-2" />
          </template>

        </sys-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FiltroPorNivelDeEstoque from "../../dashboard/produtos/FiltroPorNivelDeEstoque.vue";
import NiveisDeEstoque from "../../dashboard/produtos/NiveisDeEstoque";
import DetalhamentoProduto from "../../produto/detalhes/Index.vue";
import ReponsividadeDeAltura from "./../../../helpers/ResponsiveHeight.js";
import { buscarCompraFornecedor } from "../../../helpers/index";
import { mapGetters } from "vuex";
import $axios from '../../../api/api.js';
import IndicadoresAPI from "./../../../api/indicadores";

import HeaderDialogStatusProduto from "./Exports/HeaderDialogStatusProduto";
import PropsDialogStatusProduto from "./Exports/PropsDialogStatusProduto";
import FooterDataTable from '../../dashboard/produtos/FooterDataTable.vue';
import moment from 'moment';
import PedidosEmTransitoDialog from '../../dashboard/produtos/PedidosEmTransitoDialog.vue';

export default {
  mixins: [
    ReponsividadeDeAltura,
    NiveisDeEstoque
  ],

  components: {
    IndicadoresAPI,
    DetalhamentoProduto,
    FiltroPorNivelDeEstoque,
    FooterDataTable,
    PedidosEmTransitoDialog
  },

  model: {
    prop: "valorModel",
    event: "change",
  },

  props: PropsDialogStatusProduto,

  data () {
    return {
      desserts: [],
      pesquisar: "",
      itens_selecionados_tabela: [],
      detalhes_produto: [],
      timer_scroll_data_table: null,
      todos_itens_paginados_carregados: false,
      loading_table: false,
      itens_por_pagina: 300,
      timer_pesquisa_key_press: null,
      nivel_estoque: [],
    }
  },

  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      loading: "loading/getLoadingTable",
      filialCompra: "usuario/getFilialCompras"
    }),

    STATUS_FORMATADO () {
      return this.parametros_dialog.status
        .replaceAll('_', ' ')
        .toUpperCase()
    },

    HEADERS_COMP () {
      return HeaderDialogStatusProduto;
    },

    PAGINA_ITENS_ATUAL() {
      return Math.ceil(this.desserts.length / this.itens_por_pagina);
    },

    MES_ANO() {
      return moment(this.parametros_dialog.periodo).format('MM/YYYY');
    }
  },

  watch: {
    pesquisar(valor) {
      this.desserts = [];
      this.todos_itens_paginados_carregados = false;
      this.getProdutosAposUmTempo();
    },

    nivel_estoque() {
      this.desserts = [];
      this.todos_itens_paginados_carregados = false;
      if (this.valorModel) {
        this.getProdutosAposUmTempo();
      }
    },

    parametros_dialog(valor) {
      this.desserts = [];
      this.itens_por_pagina = 300;
      this.pesquisar = '';

      this.getProdutos();
    }
  },

  methods: {
    itemEmTransito(valor) {

      const results = valor;
      results.lista_pedidos_em_aberto = valor.lista_pedidos_em_aberto;

      return results;
    },

    classesProduto(produto) {
      return {
        'text-red': produto.status === 'FL',
      };
    },

    getProdutosAposUmTempo() {
      clearTimeout(this.timer_pesquisa_key_press);
      this.timer_pesquisa_key_press = setTimeout(() => this.getProdutos(), 1500);
    },

    buscarProdutosSeTiverNoFinalDaRolagem({scrollHeight, scrollTop, offsetHeight}) {
      if ((scrollTop + offsetHeight + 50) < scrollHeight || this.loading_table) {
        return;
      }

      clearTimeout(this.timer_scroll_data_table);
      this.timer_scroll_data_table = setTimeout(() => this.getProdutos(), 500)
    },

    getProdutos() {
      if (this.todos_itens_paginados_carregados) {
        return;
      }

      this.loading_table = true;

      const params = this.parametros_dialog;

      params.pagina = (this.PAGINA_ITENS_ATUAL + 1);
      params.itens_por_pagina = this.itens_por_pagina;
      params.pesquisar = this.pesquisar;
      params.nivel_estoque = this.nivel_estoque;


      this.$store.dispatch(
        "loading/addRequisicao",
        IndicadoresAPI.getDialogIndicadorStatusProdutos(params)
          .then((response) => {
            const { token, dados_dialog } = response.data;
            localStorage.setItem("token", token);

            this.desserts = this.desserts.concat(dados_dialog);
            this.statusDialog = true;
            this.loading_table = false;

            if (dados_dialog.length < this.itens_por_pagina) {
              this.todos_itens_paginados_carregados = true;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    pushTelaCompras(item) {
      const fornecedorSelecionado = {
        id: item.idfornecedor,
        razao_social: item.razao_social,
        produto: {
          id_produto: item.id_produto,
          nome_produto: item.descricao_produto
        }
      };

      buscarCompraFornecedor(fornecedorSelecionado, 1);
    },

    fechar () {
      this.nivel_estoque = [];
      this.$emit('change', false);
    },

    exportarRelatorio() {
      let url = 'exportar_excel_indicador_status_produtos';

      url += "?grupo=" + this.parametros_dialog.grupo;
      url += "&filial=" + this.parametros_dialog.filial;
      url += "&segmento=" + this.parametros_dialog.segmentos;
      url += "&fornecedor=" + this.parametros_dialog.fornecedores;
      url += "&comprador=" + this.parametros_dialog.compradores;
      url += "&periodo=" + this.parametros_dialog.periodo;
      url += "&tipo=" + this.parametros_dialog.status;
      url += "&selecionado_grid=" + this.parametros_dialog.selecionado_grid;
      url += "&pesquisar=" + this.pesquisar;
      url += "&nivel_estoque=" + this.nivel_estoque;

      window.open($axios.defaults.baseURL + "/" + url, "_blank");
    }
  }

}
</script>

<style scoped>
#titulo {
  height: 60px;
  background: #042333;
  color: white;
  padding: 0 10px 0 20px;
  align-items: center;
}

#data-table-dialog-status-produto .v-data-table__wrapper table tbody tr td  {
  font-size: 12px;
  padding: 1px 5px 1px 5px;
}

#data-table-dialog-status-produto .v-data-table__wrapper table thead tr th  {
  font-size: 12px;
  padding: 0 4px 0 4px;
}

.border-right-table-dialog-status-produto {
  border-right: 1px solid rgba(0,0,0, 1);
}
</style>
